export { WindowTokenModule, WINDOW } from './src/ngx-window-token';
//# sourceMappingURL=ngx-window-token.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/ngx-window-token/dist/ngx-window-token.js
// module id = ../../../../ngx-window-token/dist/ngx-window-token.js
// module chunks = 5